var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1466 5.17506L18.8442 8.83224M19.2362 3.91391L20.0851 4.7629C20.8662 5.54395 20.8662 6.81028 20.0851 7.59133L8.84933 18.8271C8.62978 19.0467 8.36213 19.2121 8.06758 19.3103L3.94804 20.6835C3.55716 20.8138 3.18529 20.4419 3.31558 20.051L4.68876 15.9315C4.78695 15.6369 4.95237 15.3693 5.17192 15.1497L16.4077 3.9139C17.1888 3.13286 18.4551 3.13286 19.2362 3.91391Z",
    stroke: "#675D75",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d46bc4a3dac277de051d6528beea7efd.svg";
export { ForwardRef as ReactComponent };